import React from 'react';
import { TextLarge } from '../../components/text';
import { CardTheme } from '../../components/card';
import { ResponsivePageLayout } from '../../components/page/responsive-layout/ResponsivePageLayout';
import { ContainerButton } from '../../styles/global-style';
import { useGetUserPermissionList } from './hooks/useGetUserPermissionList';
import { Spin } from 'antd';
import { Icon } from '../../resources';
import { ButtonTheme } from '../../components/buttons';
import { StyledContainer } from '../../components/container/styles';

export const UserPermission = () => {
  const {
    formSearch,
    formSearchObj,
    dataTable,
    isPending,
    onSelectChange,
    selectedRowKeys,
    columnsData,
    onFetch,
    handleSubmitAccident,
    isUpdateUser,
    openConfirmModal,
  } = useGetUserPermissionList();

  return (
    <Spin spinning={isUpdateUser}>
      <StyledContainer>
        <TextLarge text="ปรับสิทธิ์เมนู" />
        <CardTheme>
          <ResponsivePageLayout
            searchLayout={{
              title: 'ค้นหาข้อมูล',
              icon: <Icon.Todo />,
              formSearch,
              useFormParam: formSearchObj,
              ignoreDateEmpty: true,
              onSearch: onFetch,
            }}
            tableLayout={{
              columns: columnsData,
              dataSource: dataTable,
              loading: isPending,
              hasPagination: true,
              rowKey: 'id',
              rowSelection: {
                selectedRowKeys,
                onChange: onSelectChange,
              },
              extraContent: (
                <ContainerButton right>
                  <ButtonTheme
                    useFor="REGISTER2"
                    title="บันทึก"
                    onClick={() => openConfirmModal({ onOk: handleSubmitAccident })}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginBottom: '30px' }}
                  />
                </ContainerButton>
              ),
            }}
          />
        </CardTheme>
      </StyledContainer>
    </Spin>
  );
};
